import * as types from './mutation-types'

const state = {
  startedTurn: false,
  turn: 1,
  minPoints: 100,
  finished: false,
  level: null,
  tips: null,
  players: [],
  mediatorID: null,
  currentPlayerID: null,
  tip: 1,
  playedTips: [],
  winnerID: null
}

const getters = {
  getLevel (state) {
    return state.level
  },
  getTips (state) {
    return state.tips
  },
  getAllPlayers (state) {
    return state.players
  },
  getPlayers (state) {
    return state.players.filter(player => player.id !== state.mediatorID)
  },
  getMediator (state) {
    return state.players.filter(player => player.id === state.mediatorID)[0]
  },
  getCurrentPlayerID (state) {
    return state.currentPlayerID
  },
  getFinished (state) {
    return state.finished
  },
  getTurn (state) {
    return state.turn
  },
  getPlayedTips (state) {
    return state.playedTips
  },
  getTip (state) {
    return state.tip
  },
  getStartedTurn (state) {
    return state.startedTurn
  },
  getWinner (state) {
    return state.players.filter(player => player.id === state.winnerID)[0]
  }
}

const actions = {
  startGame ({ commit }, settings) {
    let id = 1
    settings.players = settings.players.map((item) => {
      return {
        id: id++,
        avatar: item.name,
        user: item.user || null,
        points: 0
      }
    })
    commit(types.NEW_GAME, settings)
  },
  addPoints ({ commit }, { playerID, points }) {
    commit(types.ADD_POINTS, { playerID, points })
  },
  hit ({ commit, state }) {
    let points = state.tips - state.playedTips.length
    commit(types.ADD_POINTS, {
      playerID: state.currentPlayerID,
      points: points
    })
    commit(types.NEXT_CARD)
  },
  missed ({ commit, state, rootGetters }) {
    let cardTips = rootGetters.getCard.card_tips.length
    if (
      state.turn === state.tips ||
      state.turn === cardTips
    ) {
      commit(types.ADD_POINTS, {
        playerID: state.mediatorID,
        points: 1
      })
      commit(types.NEXT_CARD)
    } else {
      let nextPlayerID = null
      let players = state.players.filter(player => player.id !== state.mediatorID)
      let itsNext = false
      players.map((player) => {
        if (itsNext) {
          nextPlayerID = player.id
          itsNext = false
        }
        if (player.id === state.currentPlayerID) {
          itsNext = true
        }
      })
      if (!nextPlayerID) {
        nextPlayerID = players[0].id
      }
      commit(types.NEXT_PLAYER, nextPlayerID)
      commit(types.ADD_POINTS, {
        playerID: state.mediatorID,
        points: 1
      })
      commit(types.NEXT_TURN)
      commit(types.ADD_PLAYED_TIP, state.tip)
    }
  },
  rollbackTurn ({ commit, state }) {
    if (state.turn > 1) {
      let players = state.players.filter(player => player.id !== state.mediatorID)
      let nextPlayerID = null
      let prevPlayerID = null
      players.map((player) => {
        if (player.id === state.currentPlayerID) {
          nextPlayerID = prevPlayerID
        }
        prevPlayerID = player.id
      })
      if (!nextPlayerID) {
        nextPlayerID = players.reverse()[0].id
      }
      commit(types.NEXT_PLAYER, nextPlayerID)
      commit(types.SUBTRACT_POINTS, {
        playerID: state.mediatorID,
        points: 1
      })
      commit(types.PREV_TURN)
      commit(types.ROLLBACK_PLAYED_TIP)
    }
  },
  setTip ({ commit }, tip) {
    commit(types.SET_TIP, tip)
  },
  beginTurn ({ commit }) {
    commit(types.BEGIN_TURN)
  }
}

const mutations = {
  [types.NEW_GAME] (state, settings) {
    state.level = settings.level
    state.tips = settings.tips
    state.players = settings.players
    state.mediatorID = settings.players[0].id
    state.currentPlayerID = settings.players[1].id
    state.startedTurn = false
    state.finished = false
    state.turn = 1
    state.tip = 1
    state.playedTips = []
    if (!settings.minPoints) {
      state.minPoints = state.tips * 5
    }
  },
  [types.ADD_POINTS] (state, data) {
    let finished = false
    state.players = state.players.map((item) => {
      if (item.id === data.playerID) {
        item.points += data.points
        if (item.points >= state.minPoints) {
          finished = true
          state.winnerID = data.playerID
        }
      }
      return item
    })
    state.finished = finished
  },
  [types.SUBTRACT_POINTS] (state, data) {
    state.players = state.players.map((item) => {
      if (item.id === data.playerID) {
        item.points -= data.points
      }
      return item
    })
  },
  [types.SET_MEDIATOR] (state, playerID) {
    state.mediatorID = playerID
  },
  [types.NEXT_PLAYER] (state, playerID) {
    state.currentPlayerID = playerID
  },
  [types.NEXT_TURN] (state) {
    state.turn = state.turn + 1
  },
  [types.PREV_TURN] (state) {
    state.turn = state.turn - 1
  },
  [types.SET_TIP] (state, tip) {
    state.tip = tip
  },
  [types.ADD_PLAYED_TIP] (state, tip) {
    state.playedTips.push(tip)
  },
  [types.CLEAN_PLAYED_TIP] (state, tip) {
    state.playedTips = []
  },
  [types.ROLLBACK_PLAYED_TIP] (state) {
    state.playedTips.pop()
  },
  [types.NEXT_CARD] (state) {
    state.startedTurn = false
    state.turn = 1
    state.tip = 1
    state.playedTips = []

    let oldMediator = state.players.shift()
    state.players.push(oldMediator)

    let mediator = state.players[0]
    let player = state.players[1]
    state.mediatorID = mediator.id
    state.currentPlayerID = player.id
  },
  [types.BEGIN_TURN] (state) {
    state.startedTurn = true
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/game.js